module.exports = __webpack_public_path__ + "img/footer_brilliant.738825b3.png";